import { render } from "./Content-block.vue?vue&type=template&id=a80a189e&scoped=true"
import script from "./Content-block.vue?vue&type=script&lang=js"
export * from "./Content-block.vue?vue&type=script&lang=js"

import "./contentBlockstyle.scss?vue&type=style&index=0&id=a80a189e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80a189e"]])

export default __exports__